import React, { useContext, useEffect, useState } from "react";
import api from "../../services/api";
import Form from "../../components/form";
import AppContext from "../../container/context";

export default function Ciclo(props) {
  const [cicloId] = useState(Number(props.match.params.id));
  const [ciclo, setCiclo] = useState({});
  const history = props.history;
  const { notification } = useContext(AppContext);

  useEffect(() => {
    if (cicloId > 0) {
      carregar();
    }
  }, []);

  const carregar = () => {
    api.get("ciclos/carregar", { id: cicloId }).then((res) => {
      setCiclo(res);
    });
  };

  const salvar = (form) => {
    const dadosSalvar = form;

    if (cicloId > 0) {
      dadosSalvar.id = cicloId;

      api
        .post("ciclos/editar", dadosSalvar)
        .then((res) => {
          if (res.id) {
            notification("success", "Id do ciclo salvo!");

            history.push("/app/ciclo");
          } else {
            notification(
              "warning",
              "Não foi possível salvar o ciclo. Verifique as informações."
            );
          }
        })
        .catch((err) => {
          const { data } = err;

          switch (data[0]) {
            case 1:
              return notification("error", "Nome inválido");

            default:
              return notification("error", "Erro ao editar o material");
          }
        });
    } else {
      api
        .put("ciclos/inserir", dadosSalvar)
        .then((res) => {
          if (res.id > 0) {
            notification("success", "Id do ciclo salvo!");
            history.push("/app/ciclo");
          } else {
            notification(
              "warning",
              "Não foi possível salvar o ciclo. Verifique as informações."
            );
          }
        })
        .catch((err) => {
          const { data } = err;

          switch (data[0]) {
            case 1:
              return notification("error", "Nome inválido");
            default:
              return notification("error", "Erro ao salvar o ciclo");
          }
        });
    }
  };

  const fDados = {
    title: "Ciclo",
    form: {
      nome: {
        label: "Nome",
        type: "text",
        space: 4,
        value: ciclo.nome,
      },
      numero: {
        label: "Número de ordem",
        type: "number",
        space: 3,
        value: ciclo.numero,
      },
      identificador: {
        label: "Identificador",
        type: "text",
        space: 3,

        value: ciclo.identificador,
      },
      ativo: {
        label: "Ativo",
        type: "check",
        space: 2,
        value: cicloId > 0 ? ciclo.ativo : true,
      },
    },

    submit: {
      label: "Salvar",
      action: salvar,
    },
    history,
    close: true,
  };

  return (
    <div>
      <Form formData={fDados} />
    </div>
  );
}
